module.exports = __webpack_public_path__ + "img/service-options-swoop-chevy.da518a1b.jpg";